/** 30-minute-before task reminder math — pure, unit-tested. Server push and
 *  the local in-app bell share this contract (HH:MM zero-padded, local time). */

export const REMINDER_LEAD_MINUTES = 30;

/** Zero-padded local HH:MM for a Date. */
export function minuteKey(date: Date): string {
  return `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
}

/**
 * Is `now` inside the 30-minutes-before reminder minute of a task whose
 * dueTime is `hh:mm` today? Only same-day reminders here (the server push
 * owns the date-rollover case for post-midnight tasks).
 */
export function isReminderMinute(dueTime: string, now: Date): boolean {
  const match = /^(\d{1,2}):(\d{2})$/.exec(dueTime ?? "");
  if (!match) return false;
  const target = new Date(now);
  target.setHours(Number(match[1]), Number(match[2]) - REMINDER_LEAD_MINUTES, 0, 0);
  // Same-day only: a 00:10 task's reminder would land at 23:40 the previous
  // evening — the server push owns those, the local bell must stay silent.
  if (target.getDate() !== now.getDate() || target.getMonth() !== now.getMonth()) return false;
  return minuteKey(target) === minuteKey(now);
}

/** Stable per-day reminder id so a reminder never fires twice. */
export function reminderId(scope: string, dayKey: string, id: string): string {
  return `${scope}:${dayKey}:${id}`;
}
